import { z } from "zod";
import { orderGroupIdZodSchema } from "../order-groups/order-group-id";
import { orderIdZodSchema } from "../orders/order-id";
import { payRequestIdZodSchema } from "../pay-requests/pay-request-id";
import { productIdZodSchema } from "../products/product-id";
import { providerIdZodSchema } from "../providers/provider-id";
import { customerIdZodSchema } from "../users/customer-id";
import { userIdZodSchema } from "../users/user-id";

const smsSendReferencesZodObject = z.object({
    customerId: userIdZodSchema.or(customerIdZodSchema).optional(),
    orderGroupId: orderGroupIdZodSchema.optional(),
    orderId: orderIdZodSchema.optional(),
    payRequestId: payRequestIdZodSchema.optional(),
    productId: productIdZodSchema.optional(),
    providerId: providerIdZodSchema.optional(),
    requestedBy: z.string().optional(),
    towniRequestId: z.string().optional(),
    towniSessionId: z.string().optional(),
});

type SmsSendReferences = z.infer<typeof smsSendReferencesZodObject>;

export { smsSendReferencesZodObject };
export type { SmsSendReferences };
